import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addMessageOmniChat, updateMessageOmniChat, useSendOmniChatMessageMutation } from 'services';
import { AppDispatch } from 'store';
import { CreateOmniChannelMessageDto, FileUpload, OmniChannelMessageDto } from 'types';
import { useUploadForm } from 'hooks/useUploadForm';
import { useOmniChatReplyMessage } from './useOmniChatReplyMessage';
import { MESSAGE_REF_TYPE } from 'utils';
export function useSentOmniChatMessage(chatId: number, chatSessionId: number, endpointNameMessages?: string) {
  const dispatch = useDispatch<AppDispatch>();
  const { handleMultiUpload } = useUploadForm();

  const [sendMessage] = useSendOmniChatMessageMutation();
  const { messageReplied, handleRemoveOmniReplyMessage } = useOmniChatReplyMessage();

  const dispatchAddMessage = useCallback(
    (data: OmniChannelMessageDto) => {
      if (endpointNameMessages) dispatch(addMessageOmniChat(data, endpointNameMessages, { chatId, chatSessionId }));
    },
    [endpointNameMessages]
  );

  const dispatchUpdateMessage = useCallback(
    (data: OmniChannelMessageDto, tempMessageId: number) => {
      if (endpointNameMessages)
        dispatch(updateMessageOmniChat(data, tempMessageId, endpointNameMessages, { chatId, chatSessionId }));
    },
    [endpointNameMessages]
  );

  const handleAddOmniMessage = (data: OmniChannelMessageDto) => {
    dispatchAddMessage(data);
  };

  const handleUpdateAddOmniMessage = (data: OmniChannelMessageDto, tempMessageId: number) => {
    dispatchUpdateMessage(data, tempMessageId);
  };

  const handleSentOmniMessage = async (data: Omit<CreateOmniChannelMessageDto, 'fileId'> & { fileId?: FileUpload }) => {
    const { fileId } = data;
    const uploadedOtherFiles = fileId ? await handleMultiUpload([fileId]) : [];
    let isReply = Boolean(messageReplied && messageReplied.chatSessionId === chatSessionId);

    return handleSend({
      chatSessionId,
      messageType: data.messageType,
      content: data.content,
      fileId: uploadedOtherFiles[0],
      refType: isReply ? MESSAGE_REF_TYPE.REPLY : undefined,
      refMessage: isReply ? messageReplied : undefined
    });
  };

  const handleSend = (data: CreateOmniChannelMessageDto) => {
    return sendMessage({
      ...data
    }).unwrap();
  };

  return {
    handleAddOmniMessage,
    handleUpdateAddOmniMessage,
    handleSentOmniMessage
  };
}
